import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import {
  InboundOrderDto,
  OrderAttachmentDto,
} from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { PaymentConfirmReprovedComponent } from '../payment-confirm-reproved/payment-confirm-reproved.component';
import * as saveAs from 'file-saver';
import { PaymentReprovedInboundComponent } from '../payment-reproved-inbound/payment-reproved-inbound.component';
import { SettlementInfoConfirmComponent } from '../settlement-info-confirm/settlement-info-confirm.component';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { PaymentConfirmApprovedComponent } from '../payment-confirm-approved/payment-confirm-approved.component';
import { ApprovePaymentDto } from 'src/app/domain/models/dto/approvePayment.dto';

@Component({
  selector: 'app-payment-confirm',
  templateUrl: './payment-confirm.component.html',
  styleUrls: ['./payment-confirm.component.scss'],
})
export class PaymentConfirmComponent implements OnInit {
  boobleModalData: any;
  currency: any;
  moedas = Moedas;
  rType: string = '';

  iof: number;
  ir: number;
  commercial: number;

  private readonly notifier: NotifierService;
  public loading: boolean;
  private destroy$ = new Subject<void>();

  constructor(
    private modalService: BoobleModalService,
    private router: Router,
    private readonly ordersService: OrdersService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.rType = this.router.url.includes('0') ? '0' : '1';

    if (typeof this.boobleModalData === 'number') {
      this.loading = true;
      this.ordersService
        .getOrderById(this.boobleModalData, "true")
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.loading = false;
            this.boobleModalData = result.data;
            this.initializeComponent();
          },
          error: (err) => {
            this.loading = false;
          },
        });
    } else {
      this.initializeComponent();
    }
  }

  initializeComponent() {
    this.currency = this.moedas.find(
      (moeda) => moeda.id === this.boobleModalData.currency.id
    );

    if (this.boobleModalData.quotations?.length > 0) {
      const quotation = this.boobleModalData.quotations[0];
      if (this.boobleModalData.remmitanceType === 'OUTBOUND') {
        this.ir = quotation.irOutbound;
        this.iof = quotation.iofOutbound;
        this.commercial = Number(
          (quotation.rate + quotation.rate * quotation.spread).toPrecision(5)
        );
      } else if (this.boobleModalData.remmitanceType === 'INBOUND') {
        this.ir = quotation.irInbound;
        this.iof = quotation.iofInboud;
        this.commercial = Number(
          (quotation.rate - quotation.rate * quotation.spread).toPrecision(5)
        );
      }
    }
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  increasePercentage(value: number, percentage: number) {
    return value + value * percentage;
  }

  downloadAttachment(orderAttachment: OrderAttachmentDto) {
    this.ordersService.downloadOrderAttachment(orderAttachment.id).subscribe({
      next: (data: any) => saveAs(data, orderAttachment.fileName),
    });
  }

  attachmentFileName(fileName: string) {
    return fileName.substring(fileName.lastIndexOf('-') + 1, fileName.length);
  }

  getIr(rate: number, spread: number, taxIr: number, ptax: number) {
    const residualIr =
      ((this.increasePercentage(rate, spread) < ptax
        ? ptax
        : this.increasePercentage(rate, spread)) *
        this.boobleModalData.amount) /
      (1 - taxIr);
    return residualIr * taxIr;
  }

  approvePaymentConfirm() {
    this.openPaymentConfirmApprovedModal(this.boobleModalData);
  }

  approvePaymentInbound() {
    const approveData = new ApprovePaymentDto();
    approveData.ValueApprovedPayment =
      this.boobleModalData?.quotations[0]?.amountMN || 0;

    this.ordersService
      .approvePayment(this?.boobleModalData.id, approveData)
      .subscribe({
        next: () => {
          this.loading = false;
          this.closeModal();
          this.openSettlementConfirmModal(this.boobleModalData);
          this.ordersService.updateOrderView();
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }

  openPaymentConfirmReprovedModal(order: InboundOrderDto) {
    this.modalService.present(PaymentConfirmReprovedComponent, order);
  }

  openPaymentConfirmApprovedModal(order: InboundOrderDto) {
    this.modalService.present(PaymentConfirmApprovedComponent, order);
  }

  openSettlementConfirmModal(order: InboundOrderDto) {
    this.modalService.present(SettlementInfoConfirmComponent, order);
  }

  openPaymentReprovedInboundModal(order: InboundOrderDto) {
    this.modalService.present(PaymentReprovedInboundComponent, order);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
